import React from 'react';

import StdDialog from 'components/Dialogs/StdDialog';
import DrawerDialogFrame from 'components/Drawers/DrawerDialogFrame';
import StandardDrawer, { StandardDrawerLayerProvider } from 'components/Drawers/StandardDrawer';

import type { ScheduledTransactionEditSurfaceMode } from './ScheduledTransactionEditViewModel';

type Props = {
  children: React.ReactNode;
  onBack?: () => void;
  onClose: () => void;
  onCloseClean: () => void;
  open: boolean;
  showAssignSplits: boolean;
  showBackButton: boolean;
  surfaceMode: ScheduledTransactionEditSurfaceMode;
  title: string;
};

export default function ScheduledTransactionEditSurface({
  children,
  onBack,
  onClose,
  onCloseClean,
  open,
  showAssignSplits,
  showBackButton,
  surfaceMode,
  title,
}: Props): React.JSX.Element | null {
  const drawerContent = (
    <DrawerDialogFrame title={title} onBack={onBack} onClose={onCloseClean} showBackButton={showBackButton}>
      {children}
    </DrawerDialogFrame>
  );

  if (surfaceMode === 'embedded-root-drawer') {
    return <StandardDrawerLayerProvider>{drawerContent}</StandardDrawerLayerProvider>;
  }

  if (surfaceMode === 'drawer') {
    return (
      <StandardDrawer onClose={onClose} open={open && !showAssignSplits} variant='temporary' width='Medium'>
        {drawerContent}
      </StandardDrawer>
    );
  }

  return (
    <StdDialog
      aria-labelledby='edit-recurrence-dialog'
      onBack={onBack}
      onClose={onClose}
      open={open && !showAssignSplits}
      showBackButton={showBackButton}
      size='md'
      title={title}
    >
      {children}
    </StdDialog>
  );
}
